import { Refinance } from '../../components/meta';
import page from '../shared/qualify/page';
import Dashboard from './dashboard';

export default ({ path, actionPipe }) =>
  page({
    path,
    actionPipe,
    scenario: 'RefiFull',
    Dashboard,
    meta: Refinance
  });



// WEBPACK FOOTER //
// ./src/products/refi-full/index.js